import type { AppState } from 'store/state';

export function addAnswer(state: AppState, payload: Partial<AppState>) {
	if (!payload.riskq?.length) return state;
	const [answer] = payload.riskq;
	const is = state.riskq.some(x => {
		return x.choiceId === answer.choiceId && x.questionId === answer.questionId && x.testId === answer.testId;
	});
	return is ? state : { ...state, riskq: [...state.riskq, ...payload.riskq] };
}

export function removeAnswer(state: AppState, payload: Partial<AppState>) {
	if (!payload.riskq?.length) return state;
	const [answer] = payload.riskq;
	const riskq = state.riskq.filter(x => {
		return !(
			x.choiceId === answer.choiceId &&
			x.questionId === answer.questionId &&
			x.testId === answer.testId
		);
	});
	return { ...state, riskq };
}

export function removeAnswers(state: AppState, payload: Partial<AppState>) {
	if (!payload.riskq?.length) return state;
	const [answer] = payload.riskq;
	const riskq = state.riskq.filter(x => {
		return !(x.questionId === answer.questionId && x.testId === answer.testId);
	});
	return { ...state, riskq };
}
